<script lang="ts">
    import {getLocalization} from 'src/core';
    import {get} from 'svelte/store';
    import {exists} from 'shared/utils/custom-utils';
    import {callCommand} from '@milkdown/utils';
    import {getRichtextAreaContext} from '../../richtext-area.context';
    import {wrapInBlockquoteCommand} from '@milkdown/preset-commonmark';
    import ToolbarButton from './ToolbarButton.svelte';

    const {editor$} = getRichtextAreaContext();
    const localize = getLocalization();

    function wrapInQuote() {
        const editor = get(editor$);
        if (!exists(editor)) {
            return;
        }

        editor.action(
            callCommand(wrapInBlockquoteCommand.key)
        );
    }
</script>

<ToolbarButton icon="quote-right"
               tooltipLabel={localize(/* @kp-localization richTextArea.tools.quote */ 'richTextArea.tools.quote')}
               on:click={wrapInQuote}/>